import Moment from 'moment';
import PropTypes from 'prop-types';

const RsvpItem = (props) => {
  const {
    className,
    data: {
      id,
      date,
      time,
      agency,
      address,
      city,
      state,
      zipCode,
      infoName,
      infoNumber,
      // email
    }
  } = props;
  const formattedDate = new Moment(date).format('dddd, MMMM DD, YYYY');

  const passDataId = (event) => {
    const dataId = event.target.getAttribute('data-nightid');
    const dataTarget = document.getElementById('id');

    dataTarget.value = dataId;
  };

  const isNotEmpty = (value) => {
    let returnVar = true;

    if (value !== '') {
      returnVar = true;
    } else {
      returnVar = false;
    }

    return returnVar;
  };

  return (
    <div className={className}>
      <div className="caribbean-nights-data-block">
        <div className="caribbean-nights-data-block-top">
          <h2 className="block-title">{formattedDate}</h2>
          <p className="block-time">{time}</p>
        </div>
        <div className="caribbean-nights-data-block-content">
          <div className="block-presented"><span className="highlighted">
            Presented By:</span> {agency}
          </div>
          <div className="block-location">
            <span className="highlighted">Event Location:</span>
            {` ${address}, ${city}, ${state} ${zipCode}`}
          </div>
          <div className="block-more-info" x-ms-format-detection="none">
            <span className="highlighted">For More Information: </span>
            {isNotEmpty(`${infoName}`) && ` ${infoName},`} <span>{` ${infoNumber}`}</span>
          </div>
        </div>
        <div className="caribbean-nights-data-block-order">
          <a href="#caribbean-nights-form-wrap" className="caribbean-nights-data-block-order-button js-magnific-popup" data-nightid={id} onClick={passDataId}>RSVP BY E-MAIL</a>
          <div className="caribbean-nights-data-block-order-policy">
            <a href="/general/privacy/">PRIVATE POLICY <i className="icon-reading" /></a>
          </div>
        </div>
      </div>
    </div>
  );
};

RsvpItem.propTypes = {
  className: PropTypes.string,
  data: PropTypes.object
};

RsvpItem.defaultProps = {
  data: {}
};

export default RsvpItem;
